export let BlockType = /*#__PURE__*/function (BlockType) {
  BlockType["SOFT_BLOCK"] = "SOFT_BLOCK";
  BlockType["HARD_BLOCK"] = "HARD_BLOCK";
  BlockType["TERMINATE_ACCOUNT"] = "TERMINATE_ACCOUNT";
  return BlockType;
}({});